import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const env = getEnvironment();

interface PushSubscriptionPayload {
    account_id: string;
    subscription: PushSubscription;
    language: string;
}

/**
 * Subscribes the user to push notifications by sending the subscription details to the server.
 * @param payload - Contains session token and subscription details.
 */
export const subscribeToPushNotifications = async (
    payload: PushSubscriptionPayload
): Promise<void> => {
    try {
        console.log("Attempting to subscribe to push notifications...");
        const response = await axios.post(
            `${env.server_address}/account/subscribe`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status !== 200) {
            throw new Error(`Failed to subscribe: ${response.statusText}`);
        }

        console.log("Push subscription successfully saved on the server.");
    } catch (error) {
        console.error("Error in subscribeToPushNotifications:", error);
    }
};

/**
 * Unsubscribes the user from push notifications by informing the server to remove the subscription.
 * @param account_id - The account's session token.
 */
export const unsubscribeFromPushNotifications = async (
    account_id: string
): Promise<void> => {
    try {
        console.log("Attempting to unsubscribe from push notifications...");
        const response = await axios.post(
            `${env.server_address}/account/unsubscribe`,
            { account_id },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status !== 200) {
            throw new Error(`Failed to unsubscribe: ${response.statusText}`);
        }

        console.log("Push subscription successfully removed on the server.");
    } catch (error) {
        console.error("Error in unsubscribeFromPushNotifications:", error);
    }
};
